<script context="module" lang="ts">
  import { Writable, writable } from "svelte/store";

  type AlertIdList = { alert: AlertContent; id: number }[];

  interface AlertContent {
    title?: string;
    message: string;
    variant?: "success" | "warning" | "critical" | "info";
  }

  interface AlertStore extends Writable<AlertIdList> {
    add: (alert: AlertContent) => void;
    remove: (id: number) => void;
  }

  let _id = 0;

  function createAlerts(): AlertStore {
    const { subscribe, set, update } = writable<AlertIdList>([]);

    return {
      set,
      update,
      subscribe,
      add: alert =>
        update(a => {
          const id = _id++;
          a.push({ alert, id });
          return a;
        }),
      remove: id =>
        update(a => {
          const i = a.findIndex(x => x.id === id);
          if (i > -1) {
            a.splice(i, 1);
          }
          return a;
        }),
    };
  }

  export const CraftAlertsStore = createAlerts();
</script>

<script lang="ts">
  import { Alert, AlertGroup } from "@getprovi/craft-svelte";

  function handleClose(id: number) {
    setTimeout(() => {
      CraftAlertsStore.remove(id);
    }, 300);
  }
</script>

<div class="craft">
  <AlertGroup>
    {#each $CraftAlertsStore as alert (alert.id)}
      <Alert {...alert.alert} overlay on:close={() => handleClose(alert.id)}>
        {alert.alert.message}
      </Alert>
    {/each}
  </AlertGroup>
</div>
